"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Likers = exports.LikeWrapperTypography = exports.WhiteLoading = exports.LikerTypography = exports.LikeIcon = exports.LikedIcon = exports.Wrapper = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _ThumbsUpOutline = _interopRequireDefault(require("../../theme/icons/ThumbsUpOutline"));

var _ThumbsUp = _interopRequireDefault(require("../../theme/icons/ThumbsUp"));

var _colors = _interopRequireDefault(require("../../theme/colors"));

var _spacing = _interopRequireDefault(require("../../theme/spacing"));

var _Loading = _interopRequireDefault(require("../Loading"));

var _Typography = _interopRequireDefault(require("../Typography"));

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  text-align: left;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    display: flex;\n    align-items: center;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    color: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    color: ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  margin-right: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  margin-right: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  cursor: ", ";\n\n  &:hover {\n    text-decoration: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Wrapper = (0, _styledComponents["default"])(_Grid["default"])(_templateObject(), function (props) {
  return props.onClick ? 'pointer' : 'auto';
}, function (props) {
  return props.onClick ? 'underline' : 'auto';
});
exports.Wrapper = Wrapper;
var LikedIcon = (0, _styledComponents["default"])(_ThumbsUp["default"])(_templateObject2(), _spacing["default"][1]);
exports.LikedIcon = LikedIcon;
var LikeIcon = (0, _styledComponents["default"])(_ThumbsUpOutline["default"])(_templateObject3(), _colors["default"].blackberry[200], _spacing["default"][1]);
exports.LikeIcon = LikeIcon;
var LikerTypography = (0, _styledComponents["default"])(_Typography["default"])(_templateObject4(), _colors["default"].lychee[100]);
exports.LikerTypography = LikerTypography;
var WhiteLoading = (0, _styledComponents["default"])(_Loading["default"])(_templateObject5(), _colors["default"].lychee[100]);
exports.WhiteLoading = WhiteLoading;
var LikeWrapperTypography = (0, _styledComponents["default"])(_Typography["default"])(_templateObject6());
exports.LikeWrapperTypography = LikeWrapperTypography;

var Likers = _styledComponents["default"].div(_templateObject7());

exports.Likers = Likers;